import { jsx } from 'react/jsx-runtime';
import { useState, useCallback, useMemo } from 'react';
import { TermsOfServiceContext } from './context.es.js';

/**
 * Terms of Service Provider.
 */ const TermsOfServiceProvider = ({ children })=>{
    const [isSanitized, setIsSanitized] = useState(false);
    const handleSetIsSanitized = useCallback(()=>{
        setIsSanitized(true);
    }, []);
    const values = useMemo(()=>({
            isSanitized
        }), [
        isSanitized
    ]);
    const actions = useMemo(()=>({
            setIsSanitized: handleSetIsSanitized
        }), [
        handleSetIsSanitized
    ]);
    return jsx(TermsOfServiceContext.Provider, {
        value: [
            values,
            actions
        ],
        children: children
    });
};

export { TermsOfServiceProvider };
//# sourceMappingURL=provider.es.js.map
